<ng-template #mapModal>
  <div class="modal-header">
    <h4 class="modal-title">{{ 'MAP.MAP' | translate }}</h4>
    <div class="ms-auto d-flex align-items-center gap-2">
      <button type="button" class="btn btn-tertiary btn-sm" (click)="toggleFullscreen()">
        {{
          isFullscreen()
            ? ('MAP.EXIT_FULLSCREEN' | translate)
            : ('MAP.ENTER_FULLSCREEN' | translate)
        }}
      </button>
      <button
        type="button"
        data-tour-id="tour-map-close"
        class="btn btn-circle btn-ghost element-cancel"
        [attr.aria-label]="'SHARED.CLOSE' | translate"
        (click)="closeModal()"
      ></button>
    </div>
  </div>

  <div class="map-modal__body modal-body">
    <div class="border-bottom pb-4 mb-4" data-tour-id="tour-map-planner">
      <app-map-planner
        (routeGenerated)="onRouteGenerated($event)"
        (routeCleared)="onRouteCleared()"
      />
    </div>

    <div class="map-modal__map">
      <app-brouter-map
        #brouterMap
        class="w-100 h-100 d-block"
        data-tour-id="tour-map-brouter"
        [waypoints]="routeWaypoints()"
        [autoFit]="!mapViewport()"
        [initialViewport]="mapViewport()"
        (routeChanged)="onRouteChanged($event)"
        (viewportChanged)="onViewportChanged($event)"
        (routingError)="onRoutingError($event)"
        (clearRequested)="onClearRequested(brouterMap)"
        (exportRequested)="onExportRequested(brouterMap)"
      />
    </div>
  </div>
</ng-template>
